 <template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "showAlert") {
        this.show(mutation.payload.message, mutation.payload.variant);
      }
    });
  },

  methods: {
    show(message, variant) {
      const h = this.$createElement;
      // Increment the toast count
      this.count++;
      // Create the message
      const vNodesMsg = h(
        "p",
        //{ class: ['mb-0'] },
        [
          //h('b-spinner', { props: { type: 'grow', small: true } }),
          //' Flashy ',
          //h('strong', {}, 'toast'),
          message,
          //h('b-spinner', { props: { type: 'grow', small: true } })
        ]
      );
      // Create the title
      const vNodesTitle = h(
        "div",
        {
          class: ["d-flex", "flex-grow-1", "align-items-baseline", "mr-2"],
        },

        [
          h("i", { class: "fas fa-check mr-1" }),
          h("strong", { class: "mr-2" }, " Sucesso!"),
        ]
      );

      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        toaster: "b-toaster-top-center",
        title: [vNodesTitle],
        solid: true,
        // variant: variant,
        autoHideDelay: 3000,
        toastClass:
          variant === "success"
            ? "toasty-success"
            : variant === "info"
            ? "toasty-info"
            : "toasty-success",
        headerClass:
          variant === "success"
            ? "toasty-success"
            : variant === "info"
            ? "toasty-info"
            : "toasty-success",
      });
    },
  },
};
</script>

<style lang="scss">
.toasty-success {
  font-size: 1rem;
  background-color: #8bc34a !important;
  color: #fff !important;
  border: none;
}
.toasty-success > button {
  color: #fff !important;
}

.toasty-info {
  font-size: 1rem;
  background-color: #17a2b8 !important;
  color: #fff !important;
  border: none;
}
.toasty-info > button {
  color: #fff !important;
}
</style>

